const state = {
  alerts: [],
  alertsDetails: {
    data: [],
    paging: {
      currentPage: 1,
      totalItemCount: 0,
      pageCount: 1,
      count: 0,
    },
    configPaginated: {
      pageSize: 15,
    },
  },
  messages: {
    data: [],
    chunked: [],
    currentIndex: 0,
    perPage: 3,
  },
  schedule: [],
  immediateMessages: [],
};

export default state;
